import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-cookie-consent',
  templateUrl: './help-cookie-consent.component.html',
  styleUrls: ['./help-cookie-consent.component.scss']
})
export class HelpCookieConsentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
